(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-advice-call"] && !Shopify.designMode) return;
  try {
    class AdviceCallComponent extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('.custom-advice__text')) return;
      this.target = this.closest('.shopify-section, dialog');
      if (!this.target) return;
      this.target.addEventListener('variant:update', this.updateText);
    }

    disconnectedCallback() {
      this.target?.removeEventListener('variant:update', this.updateText);
    }

    updateText = (event) => {
      if (event.detail.data?.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      }

      if (
        event.target instanceof HTMLElement &&
        event.target.dataset.productId &&
        this.dataset.productId &&
        event.target.dataset.productId !== this.dataset.productId
      ) {
        return;
      }

      const newHtml = event.detail.data?.html;
      if (!newHtml) return;

      const newText = newHtml.querySelector(
        `advice-call-component[data-block-id="${this.dataset.blockId}"] .custom-advice__text`
      );
      const text = this.querySelector('.custom-advice__text');
      if (!newText || !text) return;

      text.innerHTML = newText.innerHTML;
      text.hidden = newText.hidden;
    };
  }

  if (!customElements.get('advice-call-component')) {
    customElements.define('advice-call-component', AdviceCallComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-bundle-contents"] && !Shopify.designMode) return;
  try {
    const BUNDLE_CONTENTS_API_VERSION = '2026-07';

  const BUNDLE_CONTENTS_QUERY = `
    query BundleContents($id: ID!, $language: LanguageCode, $country: CountryCode)
    @inContext(language: $language, country: $country) {
      node(id: $id) {
        ... on ProductVariant {
          components(first: 50) {
            nodes {
              quantity
              productVariant {
                id
                title
                sku
                availableForSale
                image { url(transform: { maxWidth: 112, maxHeight: 112 }) altText }
                product {
                  title
                  handle
                  featuredImage { url(transform: { maxWidth: 112, maxHeight: 112 }) altText }
                }
              }
            }
          }
        }
      }
    }
  `;

  const PACKAGE_DEAL_QUERY = `
    query PackageDealContents($ids: [ID!]!, $language: LanguageCode, $country: CountryCode)
    @inContext(language: $language, country: $country) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          title
          sku
          availableForSale
          image { url(transform: { maxWidth: 112, maxHeight: 112 }) altText }
          product {
            title
            handle
            featuredImage { url(transform: { maxWidth: 112, maxHeight: 112 }) altText }
          }
        }
      }
    }
  `;

  // Porties voor nodes(ids:); houdt elke query ruim onder de complexiteitslimiet.
  const PACKAGE_DEAL_BATCH_SIZE = 50;

  class BundleContentsComponent extends HTMLElement {
    /** @type {Map<string, Promise<Array<object>>>} */
    #cache = new Map();

    /** @type {Record<string, Array<[number, number]>>} */
    #packageComponents = {};

    connectedCallback() {
      try {
        this.#packageComponents = JSON.parse(this.querySelector('[data-package-components]')?.textContent || '{}');
      } catch (error) {
        console.warn('[bundle-contents] Package-deal-metafield onleesbaar', error);
      }

      this.target = this.closest('.shopify-section, dialog');
      this.target?.addEventListener('variant:update', this.#onVariantUpdate);

      // Deal zonder dealprijs: de koopknop regelt buy-buttons zelf (Liquid), maar
      // de sticky knop zit in een core-section die we niet mogen wijzigen.
      if (this.dataset.packageDealBlocked === 'true') this.#disableSticky();

      this.#show(this.dataset.variantId);
    }

    disconnectedCallback() {
      this.target?.removeEventListener('variant:update', this.#onVariantUpdate);
    }

    #onVariantUpdate = (event) => {
      if (event.detail.data?.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      }

      if (
        event.target instanceof HTMLElement &&
        event.target.dataset.productId &&
        this.dataset.productId &&
        event.target.dataset.productId !== this.dataset.productId
      ) {
        return;
      }

      const variantId = event.detail.resource?.id;
      if (!variantId || String(variantId) === this.dataset.variantId) return;

      this.dataset.variantId = String(variantId);
      this.#show(this.dataset.variantId);
    };

    async #show(variantId) {
      if (!variantId) return;

      let components = [];
      try {
        components = await this.#fetchComponents(variantId);
      } catch (error) {
        console.warn('[bundle-contents] Componenten ophalen mislukt', error);
      }

      // Tussentijds van variant gewisseld: dit antwoord is niet meer relevant.
      if (variantId !== this.dataset.variantId) return;

      this.#render(components);

      // Alleen metafield-deals: bij native bundels volgt Shopify zelf de voorraad van de onderdelen.
      if (this.#packageComponents[variantId]) {
        this.#applyAvailability(components.filter((c) => c.productVariant.availableForSale === false).length);
      }
    }

    // Sticky balk (sections/product-information): eigen knop buiten add-to-cart-component.
    #disableSticky() {
      for (const sticky of (this.target ?? document).querySelectorAll('sticky-add-to-cart')) {
        sticky.dataset.variantAvailable = 'false';
        sticky.querySelector('.sticky-add-to-cart__button')?.setAttribute('disabled', '');
      }
    }

    /** @param {number} unavailableCount */
    #applyAvailability(unavailableCount) {
      const notice = this.querySelector('.custom-bundle-contents__notice');
      if (notice) {
        notice.hidden = unavailableCount === 0;
        notice.textContent = (this.dataset.itemsOutOfStockText || '').replace('[count]', String(unavailableCount));
      }
      if (unavailableCount === 0) return;

      const section = this.target ?? document;

      // Koopknop en sticky-knop: uitverkocht, zoals bij een gewoon uitverkocht product.
      for (const button of section.querySelectorAll('add-to-cart-component button[name="add"]')) {
        button.disabled = true;
        button.querySelector('.add-to-cart-icon')?.remove();
        const label = button.querySelector('.add-to-cart-text__content');
        if (label) label.textContent = this.dataset.soldOutText || '';
      }

      this.#disableSticky();

      for (const status of section.querySelectorAll('.custom-stock-status')) {
        const icon = status.querySelector('.product-inventory__icon');
        icon?.classList.remove('product-inventory__icon-in_stock', 'product-inventory__icon-low');
        icon?.classList.add('product-inventory__icon-out_of_stock');
        const text = status.querySelector('.product-inventory__text');
        if (text) text.textContent = this.dataset.outOfStockText || '';
      }
    }

    #fetchComponents(variantId) {
      if (!this.#cache.has(variantId)) {
        const request = this.#request(variantId);
        // Mislukte requests niet cachen, zodat een volgende variantwissel opnieuw probeert.
        request.catch(() => this.#cache.delete(variantId));
        this.#cache.set(variantId, request);
      }
      return this.#cache.get(variantId);
    }

    async #request(variantId) {
      const packageComponents = this.#packageComponents[variantId];
      if (Array.isArray(packageComponents) && packageComponents.length) {
        return this.#requestPackageDeal(packageComponents);
      }

      const data = await this.#query(BUNDLE_CONTENTS_QUERY, { id: `gid://shopify/ProductVariant/${variantId}` });
      // Een component zonder productVariant is niet gepubliceerd op de Online Store.
      return (data?.node?.components?.nodes ?? []).filter((component) => component.productVariant);
    }

    /** @param {Array<[number, number]>} packageComponents */
    async #requestPackageDeal(packageComponents) {
      const batches = [];
      for (let i = 0; i < packageComponents.length; i += PACKAGE_DEAL_BATCH_SIZE) {
        batches.push(packageComponents.slice(i, i + PACKAGE_DEAL_BATCH_SIZE));
      }

      const results = await Promise.all(
        batches.map((batch) =>
          this.#query(PACKAGE_DEAL_QUERY, { ids: batch.map(([id]) => `gid://shopify/ProductVariant/${id}`) })
        )
      );
      const nodes = results.flatMap((data) => data?.nodes ?? []);

      // nodes(ids:) houdt de volgorde aan; null = niet gepubliceerd op de Online Store.
      const components = packageComponents
        .map(([, quantity], index) => ({ quantity, productVariant: nodes[index] }))
        .filter((component) => component.productVariant);

      if (components.length < packageComponents.length) {
        console.warn(
          `[bundle-contents] ${packageComponents.length - components.length} van ${packageComponents.length} artikelen niet zichtbaar op de webshop`
        );
      }
      return components;
    }

    async #query(query, variables) {
      const response = await fetch(`/api/${BUNDLE_CONTENTS_API_VERSION}/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query,
          variables: {
            ...variables,
            language: this.dataset.language || null,
            country: this.dataset.country || null,
          },
        }),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const { data, errors } = await response.json();
      if (errors?.length) throw new Error(errors.map((e) => e.message).join('; '));
      return data;
    }

    #render(components) {
      const list = this.querySelector('.custom-bundle-contents__list');
      if (!list) return;

      list.replaceChildren(...components.map((component) => this.#renderItem(component)));
      this.hidden = components.length === 0;
    }

    #renderItem({ quantity, productVariant }) {
      const { product } = productVariant;
      const item = document.createElement('li');
      item.className = 'custom-bundle-contents__item';

      const quantityEl = document.createElement('span');
      quantityEl.className = 'custom-bundle-contents__quantity';
      quantityEl.textContent = `${quantity}×`;

      const image = productVariant.image ?? product.featuredImage;
      let imageEl;
      if (image?.url) {
        imageEl = document.createElement('img');
        imageEl.src = image.url;
        imageEl.alt = '';
        imageEl.width = 56;
        imageEl.height = 56;
        imageEl.loading = 'lazy';
        imageEl.className = 'custom-bundle-contents__image';
      } else {
        imageEl = document.createElement('span');
        imageEl.className = 'custom-bundle-contents__image custom-bundle-contents__image--placeholder';
      }

      const variantTitle = productVariant.title !== 'Default Title' ? productVariant.title : '';
      const numericVariantId = productVariant.id.split('/').pop();
      const root = window.Shopify?.routes?.root ?? '/';

      const nameEl = document.createElement('a');
      nameEl.className = 'custom-bundle-contents__name';
      nameEl.href = `${root}products/${product.handle}?variant=${numericVariantId}`;
      nameEl.textContent = variantTitle ? `${product.title} – ${variantTitle}` : product.title;

      const details = document.createElement('div');
      details.append(nameEl);

      if (productVariant.sku) {
        const skuEl = document.createElement('span');
        skuEl.className = 'custom-bundle-contents__sku';
        skuEl.textContent = productVariant.sku;
        details.append(skuEl);
      }

      if (productVariant.availableForSale === false) {
        const stockEl = document.createElement('span');
        stockEl.className = 'custom-bundle-contents__stock';
        stockEl.textContent = this.dataset.outOfStockText || '';
        details.append(stockEl);
      }

      item.append(quantityEl, imageEl, details);
      return item;
    }
  }

  if (!customElements.get('bundle-contents-component')) {
    customElements.define('bundle-contents-component', BundleContentsComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-product-specifications"] && !Shopify.designMode) return;
  try {
    class ProductSpecificationsComponent extends HTMLElement {
    connectedCallback() {
      this.target = this.closest('.shopify-section, dialog');
      if (!this.target) return;
      this.target.addEventListener('variant:update', this.updateSpecifications);
    }

    disconnectedCallback() {
      this.target?.removeEventListener('variant:update', this.updateSpecifications);
    }

    updateSpecifications = (event) => {
      if (event.detail.data?.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      }

      if (
        event.target instanceof HTMLElement &&
        event.target.dataset.productId &&
        this.dataset.productId &&
        event.target.dataset.productId !== this.dataset.productId
      ) {
        return;
      }

      const newHtml = event.detail.data?.html;
      if (!newHtml) return;

      const newSpecifications = newHtml.querySelector(
        `product-specifications-component[data-block-id="${this.dataset.blockId}"]`
      );
      if (!newSpecifications) return;

      this.innerHTML = newSpecifications.innerHTML;
    };
  }

  if (!customElements.get('product-specifications-component')) {
    customElements.define('product-specifications-component', ProductSpecificationsComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-variant-barcode"] && !Shopify.designMode) return;
  try {
    // CUSTOM (Hofman): assets/custom-jsbarcode.js wordt door de <script> hierboven
  // geladen (buiten deze javascript-tag, zie de comment daar). Die load is
  // async, dus hier gewoon pollen tot window.JsBarcode klaarstaat.
  function loadJsBarcode() {
    if (window.JsBarcode) return Promise.resolve(window.JsBarcode);
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const interval = setInterval(() => {
        if (window.JsBarcode) {
          clearInterval(interval);
          resolve(window.JsBarcode);
        } else if (Date.now() - start > 5000) {
          clearInterval(interval);
          reject(new Error('JsBarcode did not load in time'));
        }
      }, 30);
    });
  }

  // CUSTOM (Hofman): kiest de symbologie op basis van de lengte/vorm van de
  // barcode-waarde. Productbarcodes zijn doorgaans GTINs (UPC-A/EAN-13/EAN-8);
  // alles daarbuiten (letters, eigen SKU-achtige codes, afwijkende lengte)
  // valt terug op CODE128, dat vrijwel elke ASCII-tekst kan encoderen.
  function barcodeFormat(value) {
    if (/^\d{12}$/.test(value)) return 'UPC';
    if (/^\d{13}$/.test(value)) return 'EAN13';
    if (/^\d{8}$/.test(value)) return 'EAN8';
    return 'CODE128';
  }

  class ProductBarcodeComponent extends HTMLElement {
    connectedCallback() {
      this.target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
      if (!this.target) return;
      this.target.addEventListener('variant:update', this.updateBarcode);

      const bars = this.querySelector('.custom-variant-barcode__bars');
      this.renderBarcode(bars?.dataset.value || '');
    }

    disconnectedCallback() {
      this.target?.removeEventListener('variant:update', this.updateBarcode);
    }

    updateBarcode = (event) => {
      if (event.detail.data?.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      }

      if (
        event.target instanceof HTMLElement &&
        event.target.dataset.productId &&
        this.dataset.productId &&
        event.target.dataset.productId !== this.dataset.productId
      ) {
        return;
      }

      this.renderBarcode(event.detail.resource?.barcode || '');
    };

    async renderBarcode(value) {
      const bars = this.querySelector('.custom-variant-barcode__bars');
      const number = this.querySelector('.custom-variant-barcode__number');

      if (bars) bars.dataset.value = value;
      if (number) number.textContent = value;

      if (!value) {
        this.style.display = 'none';
        return;
      }

      this.style.display = '';
      if (!bars) return;

      try {
        const JsBarcode = await loadJsBarcode();
        // Blijft dit het meest recente verzoek? Bij snel wisselen van
        // variant kan een oudere renderBarcode-call later resolven.
        if (bars.dataset.value !== value) return;

        const options = { displayValue: false, margin: 0, height: 48 };
        const format = barcodeFormat(value);
        try {
          JsBarcode(bars, value, { ...options, format });
        } catch (formatError) {
          // Bv. een GTIN met een ongeldig checksum-cijfer: CODE128 legt geen
          // eisen op aan een checksum en kan alsnog scanbaar tekenen.
          if (format === 'CODE128') throw formatError;
          JsBarcode(bars, value, { ...options, format: 'CODE128' });
        }
      } catch (error) {
        bars.replaceChildren();
      }
    }
  }

  if (!customElements.get('product-barcode-component')) {
    customElements.define('product-barcode-component', ProductBarcodeComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
